<template>
  <div class="demo-spin-container" :height='height'>
    <!-- <Spin size="large"></Spin> -->
    <img src="../../../assets/loadingWu.gif" alt="" style="width:200px"/>
  </div>
</template>
<script>
export default {
  props: {
    height: {
      type: 'String',
      default: null
    }
  }
}
</script>
<style lang="less">
.demo-spin-container {
  display: inline-block;
  width: 100%;
  height: 3rem;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ivu-spin {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/teacher/components/loading.vue